import AbstractForecastColumn from "./AbstractForecastColumn.js";

/**
 * This column is used to handle the data of the current period in
 * the forecasting table. It must always be visible even if there is no data.
 *
 * @param {object} options - Options for the column.
 * @param {boolean} [options.isFrozen=false] - Whether the period is frozen.
 */
export default class CurrentPeriodForecastColumn extends AbstractForecastColumn {
	constructor({ isFrozen = false } = {}) {
		super(...arguments);
		this._isFrozen = isFrozen;
	}

	accept(visitor) {
		return visitor.visitCurrentPeriodForecastColumn(this);
	}

	isCurrentPeriodForecastColumn() {
		return true;
	}

	isFrozenPeriodForecastColumn() {
		return this._isFrozen;
	}
}
